import { createPluginFactory } from '@udecode/plate';
import { BufferEditor, BufferValue } from '~/editor/BufferEditor/types.plate';
import { isSelectionAtEndOfCurrentNode } from '~/editor/queries/isSelectionAtEndOfNode';
import {
  AutocompleteInputElementUI,
  AutocompletePluginOptions,
} from '../autocomplete';
import { normalizeMention } from '../autocomplete/commands/normalizeMention';
import { onMentionUpdated } from '../autocomplete/commands/onMentionUpdated';
import { autocompleteOnKeyDownHandler } from '../autocomplete/handlers';
import { replaceTextAfterTriggerWithMention } from '../autocomplete/transforms/replaceTextAfterTriggerWithMention';
import { withAutocomplete } from '../autocomplete/withAutocomplete';
import { getNewSuggestionsOnHashtagUpdate } from './commands/getNewSuggestionsOnHashtagUpdate';
import { TwitterHashtagInputElement } from './nodes/TwitterHashtagInputElement';
import { findAndCreateTwitterHashtags } from './transforms/findAndCreateTwitterHashtags';

/**
 * Twitter hashtag plugin factory.
 * Overrides and configures Autocomplete plugin.
 */
export const createTwitterHashtagPlugin = createPluginFactory<
  AutocompletePluginOptions<TwitterHashtagInputElement>,
  BufferValue,
  BufferEditor
>({
  key: TwitterHashtagInputElement.type,
  isElement: true,
  isInline: true,
  component: AutocompleteInputElementUI,
  options: {
    textToNodes: findAndCreateTwitterHashtags,
    onPastedText: findAndCreateTwitterHashtags,
    fetchNewSuggestions: getNewSuggestionsOnHashtagUpdate,
    shouldExitOnWhitespace: isSelectionAtEndOfCurrentNode,
    onInsertTriggerBeforeText: replaceTextAfterTriggerWithMention,
    onMentionUpdated,
    normalizeNode: (editor, nodeEntry) =>
      normalizeMention(editor, TwitterHashtagInputElement, nodeEntry),
  },
  withOverrides: withAutocomplete<TwitterHashtagInputElement>(
    TwitterHashtagInputElement
  ),
  handlers: {
    onKeyDown: autocompleteOnKeyDownHandler({
      type: TwitterHashtagInputElement.type,
      exitOnWhitespace: true,
    }),
  },
});
